export default __webpack_public_path__ + "static/media/empty-state-icon.75ca402d.svg";